import {
  getHostnameTenantSlug,
  getTenantPortalLoginRedirectUrl,
  isDevEnv,
  isSelectiveAiDomains,
  isUniversalLoginHost,
} from 'common/HelperFunctions'

type LoginResult = {
  tenant?: string
  accessToken?: string
  userType?: string
}

type RedirectOptions = {
  path?: string
  searchParams?: Record<string, string>
}

/**
 * Redirect from universal login host to the tenant workspace subdomain.
 * Returns true when a redirect was initiated.
 */
export const redirectToTenantWorkspaceIfNeeded = (
  tenant: string,
  accessToken: string,
  options?: RedirectOptions
): boolean => {
  if (!isSelectiveAiDomains()) return false
  if (!isUniversalLoginHost()) return false
  if (!tenant || !accessToken) return false

  const currentSlug = getHostnameTenantSlug()
  if (currentSlug && currentSlug === tenant) return false

  const path = options?.path ?? '/dashboard'
  const url = getTenantPortalLoginRedirectUrl(tenant, accessToken, path, options?.searchParams)
  window.location.replace(url)
  return true
}

/**
 * Post-login navigation for selective-AI universal login. Students and
 * parents both stay in the new portal (the parent end is native now).
 * Returns true when a full-page redirect was initiated.
 */
export const handlePostLoginNavigation = (
  result: LoginResult,
  options?: RedirectOptions
): boolean => {
  const {tenant, accessToken} = result
  if (!accessToken || isDevEnv()) return false

  if (isSelectiveAiDomains()) {
    return redirectToTenantWorkspaceIfNeeded(tenant ?? '', accessToken, {
      path: options?.path ?? '/dashboard',
      searchParams: options?.searchParams ?? {step: '0'},
    })
  }

  return false
}
